import Typography from '@mui/material/Typography';
import React from 'react';

import { StatusSpecs, statusSpecs } from '@/data/transactionStatuses';
import { useTranslator } from '@/hooks/useTranslator';
import { SimplifiedTransactionStatus } from '@/types/transaction';

interface Props {
  readonly status: SimplifiedTransactionStatus;
}

export const StatusCell: React.FC<Props> = (props: Props): React.ReactElement => {
  const { status } = props;

  const tr = useTranslator();
  const specs = React.useMemo((): StatusSpecs => statusSpecs(status), [status]);

  return (
    <Typography variant="body1" color={specs.color}>
      {tr(specs.label)}
    </Typography>
  );
};
